import CreateLotteryPage from "./CreateLottery/index";

export default CreateLotteryPage;
